export default {
  TT107: 0,
  TM: 1,
  TTM: 2,
};
